import { helper } from '@ember/component/helper';

export default helper(function getPostCount([postCountMap, studentId]) {
  if (!postCountMap || !studentId) {
    return 0;
  }
  return postCountMap[studentId] ?? 0;
});
